import * as yup from 'yup';
import { formRules } from '../forms.rules';

export const careerFormValidationSchema = yup.object().shape({
  vacancy_id: formRules.select({ message: 'Select vacancy', required: true }),
  name: formRules.text('Name', { onlyLetters: true, required: true }),
  email: formRules.email,
  portfolio_link: formRules.portfolio_link,
  telegram_link: formRules.telegram,
  file: formRules.file({ required: true, message: 'File is required' }),
});
